import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Thumbs, EffectFade, Autoplay } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
// import styles bundle
import 'swiper/swiper.css';
import 'swiper/css/pagination';
import './index.pcss';


document.addEventListener('alpine:init', () => {
    Alpine.data('initHorizontalSteps', () => {
        return {
            swiperThumb: null as Swiper | null,
            swiper: null as Swiper | null,
            slideIndex: 0,
            sliderPause: false,
            slidesDesktop: document.querySelectorAll('.js-step-slide-desktop'),
            index: 0,
            shown: false,
            interval: null as ReturnType<typeof setInterval> | null,
            removeActive() {
                this.slidesDesktop.forEach(item => item.classList.remove('is-active')  );
            },
            startSlideshow() {
                this.interval = setInterval(() => {
                    this.removeActive();
                    this.slidesDesktop[this.index].classList.add('is-active');
                    this.index = (this.index + 1) % this.slidesDesktop.length;
                }, 5000);
            },
            stopSlideshow() {
                if (this.interval) {
                    clearInterval(this.interval);
                }
            },
            handleStepClick($el, index) {
                this.stopSlideshow(); 
                this.removeActive();
                $el.classList.add('is-active');
                //this.item = index;
                this.index = (index + 1) % this.slidesDesktop.length;
                this.startSlideshow();
            },
            start() {
                if (window.innerWidth >= 1024) {
                    this.removeActive();
                    this.slidesDesktop[this.index].classList.add('is-active');
                    this.index = (this.index + 1) % this.slidesDesktop.length;

                    this.startSlideshow();
                } else {               
                    const swiperParams: SwiperOptions = {
                        modules: [Navigation, Keyboard, Pagination, Thumbs, EffectFade, Autoplay],
                        init: false,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                        },
                        slidesOffsetAfter: 16,
                        slideActiveClass: 'is-active',
                        spaceBetween: 8,
                        watchSlidesProgress: true,
                        slidesPerView: 1.3,
                        preventClicks: false,
                        observer: true,
                        observeParents: true,
                        breakpoints: {
                            640: {
                                slidesPerView: 2.3,
                            }
                        },
                        keyboard: {
                            enabled: true,
                        },
                        navigation: {
                            prevEl: this.$refs.buttonPrev,
                            nextEl: this.$refs.buttonNext,
                        },
                    };
                    const swiper = new Swiper(
                        this.$refs.swiperContainer,
                        swiperParams,
                    );
                    this.swiper = swiper;

                    this.$nextTick(() => {
                        swiper.init();
                    });

                    swiper.on('touchStart', () => {
                        swiper.autoplay.stop();
                    });

                    swiper.on('touchEnd', () => {
                        swiper.autoplay.start();
                    });

                }
            },
        };
    });
});
